/**
 * @generated SignedSource<<32559267f3e93dec4e22614087c3c064>>
 * @relayHash af0a655e3faf361a0bd752d984c38d42
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 60813beea58cb330d539e5ec8dacf95643df5e4008ab6e2ca093628ccd5cf9a0

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SortDirection = "ASC" | "DESC" | "%future added value";
export type JiraFieldSchemeAssociatedFieldsInput = {
  associatedIssueTypesFilter?: ReadonlyArray<JiraFieldsAssociatedIssueTypesFilterInput> | null;
  fieldTypeGroupsFilter?: ReadonlyArray<string> | null;
  nameOrDescriptionFilter?: string | null;
  requiredOnIssueTypesFilter?: ReadonlyArray<JiraFieldsRequiredOnIssueTypesFilterInput> | null;
  schemeId: string;
  sortBy?: ReadonlyArray<JiraFieldSchemesSort> | null;
};
export type JiraFieldsAssociatedIssueTypesFilterInput = {
  allIssueTypes?: boolean | null;
  issueTypeId?: string | null;
};
export type JiraFieldsRequiredOnIssueTypesFilterInput = {
  allIssueTypes?: boolean | null;
  issueTypeId?: string | null;
  noIssueTypes?: boolean | null;
};
export type JiraFieldSchemesSort = {
  direction: SortDirection;
  key: string;
};
export type JiraIssueFieldConfigWorkTypesAssociationInput = {
  schemeOrProject: JiraIssueFieldConfigSchemeOrProjectInput;
};
export type JiraIssueFieldConfigSchemeOrProjectInput = {
  projectKey?: string | null;
  schemeId?: string | null;
};
export type JiraIssueFieldConfigRequiredOnCustomisationsInput = {
  schemeOrProject: JiraIssueFieldConfigSchemeOrProjectInput;
};
export type JiraIssueFieldConfigDescriptionCustomisationsInput = {
  schemeOrProject: JiraIssueFieldConfigSchemeOrProjectInput;
};
export type FieldSchemePageQuery$variables = {
  availableOnInput: JiraIssueFieldConfigWorkTypesAssociationInput;
  cloudId: string;
  descriptionsInput: JiraIssueFieldConfigDescriptionCustomisationsInput;
  fieldSchemeAri: string;
  input: JiraFieldSchemeAssociatedFieldsInput;
  isPerSchemeFieldLimitEnabled: boolean;
  requiredOnInput: JiraIssueFieldConfigRequiredOnCustomisationsInput;
};
export type FieldSchemePageQuery$data = {
  readonly fieldSchemeNode: {
    readonly fieldsCount?: number | null;
    readonly name?: string | null;
    readonly projectsCount?: number | null;
    readonly " $fragmentSpreads": FragmentRefs<"AssociatedFieldsTable_scheme" | "PageHeaderGroup_scheme">;
  } | null;
  readonly jira_isTenantConvertedToNfa: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"AssociatedFieldsTable_query" | "PageHeaderGroup_query">;
};
export type FieldSchemePageQuery = {
  response: FieldSchemePageQuery$data;
  variables: FieldSchemePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "availableOnInput"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "descriptionsInput"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSchemeAri"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPerSchemeFieldLimitEnabled"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "requiredOnInput"
},
v7 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v8 = [
  (v7/*: any*/)
],
v9 = {
  "args": (v8/*: any*/),
  "kind": "ScalarField",
  "name": "jira_isTenantConvertedToNfa"
},
v10 = {
  "kind": "Variable",
  "name": "input",
  "variableName": "input"
},
v11 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "fieldSchemeAri"
  }
],
v12 = {
  "kind": "Variable",
  "name": "isPerSchemeFieldLimitEnabled",
  "variableName": "isPerSchemeFieldLimitEnabled"
},
v13 = {
  "kind": "ScalarField",
  "name": "name"
},
v14 = {
  "kind": "ScalarField",
  "name": "fieldsCount"
},
v15 = {
  "kind": "ScalarField",
  "name": "projectsCount"
},
v16 = [
  (v7/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v17 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v18 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v19 = {
  "kind": "ScalarField",
  "name": "endCursor"
},
v20 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v21 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    (v20/*: any*/)
  ]
},
v22 = [
  (v7/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 40
  },
  (v10/*: any*/)
],
v23 = {
  "kind": "ScalarField",
  "name": "id"
},
v24 = {
  "kind": "ScalarField",
  "name": "description"
},
v25 = {
  "kind": "ScalarField",
  "name": "issueTypeId"
},
v26 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v27 = {
  "concreteType": "JiraIssueType",
  "kind": "LinkedField",
  "name": "workTypes",
  "plural": true,
  "selections": [
    (v23/*: any*/),
    (v25/*: any*/),
    (v13/*: any*/),
    (v26/*: any*/)
  ]
},
v28 = {
  "kind": "ScalarField",
  "name": "isDefault"
},
v29 = [
  {
    "concreteType": "JiraIssueTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraIssueType",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v25/*: any*/),
          (v13/*: any*/),
          (v26/*: any*/),
          (v23/*: any*/),
          (v17/*: any*/)
        ]
      },
      (v18/*: any*/)
    ]
  },
  (v21/*: any*/)
],
v30 = [
  "input"
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "FieldSchemePageQuery",
    "selections": [
      (v9/*: any*/),
      {
        "args": [
          {
            "kind": "Variable",
            "name": "availableOnInput",
            "variableName": "availableOnInput"
          },
          (v7/*: any*/),
          {
            "kind": "Variable",
            "name": "descriptionsInput",
            "variableName": "descriptionsInput"
          },
          (v10/*: any*/),
          {
            "kind": "Variable",
            "name": "requiredOnInput",
            "variableName": "requiredOnInput"
          }
        ],
        "kind": "FragmentSpread",
        "name": "AssociatedFieldsTable_query"
      },
      {
        "alias": "fieldSchemeNode",
        "args": (v11/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": [
                  (v12/*: any*/)
                ],
                "kind": "FragmentSpread",
                "name": "PageHeaderGroup_scheme"
              },
              {
                "kind": "FragmentSpread",
                "name": "AssociatedFieldsTable_scheme"
              },
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/)
            ],
            "type": "JiraFieldScheme"
          }
        ]
      },
      {
        "args": [
          (v7/*: any*/),
          (v12/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "PageHeaderGroup_query"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "FieldSchemePageQuery",
    "selections": [
      (v9/*: any*/),
      {
        "args": (v16/*: any*/),
        "concreteType": "JiraFieldTypeGroupConnection",
        "kind": "LinkedField",
        "name": "jira_fieldTypeGroups",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraFieldTypeGroupEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "JiraFieldTypeGroup",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "displayName"
                  },
                  (v17/*: any*/)
                ]
              },
              (v18/*: any*/)
            ]
          },
          (v21/*: any*/)
        ]
      },
      {
        "args": (v16/*: any*/),
        "filters": [
          "cloudId"
        ],
        "handle": "connection",
        "key": "FilterSelectFieldTypeCategory_query_jira_fieldTypeGroups",
        "kind": "LinkedHandle",
        "name": "jira_fieldTypeGroups"
      },
      {
        "args": (v22/*: any*/),
        "concreteType": "JiraFieldSchemeAssociatedFieldsConnection",
        "kind": "LinkedField",
        "name": "jira_fieldSchemeAssociatedFields",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "totalCount"
          },
          {
            "concreteType": "JiraFieldSchemeAssociatedFieldsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "JiraFieldSchemeAssociatedField",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v23/*: any*/),
                  {
                    "concreteType": "JiraField",
                    "kind": "LinkedField",
                    "name": "field",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "fieldId"
                      },
                      (v23/*: any*/),
                      (v24/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "typeName"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "typeKey"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isFieldLocked"
                  },
                  {
                    "concreteType": "JiraIssueFieldConfig",
                    "kind": "LinkedField",
                    "name": "fieldConfig",
                    "plural": false,
                    "selections": [
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "availableOnInput"
                          }
                        ],
                        "concreteType": "JiraFieldToWorkTypesAssociation",
                        "kind": "LinkedField",
                        "name": "workTypesAssociationV2",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "availableOnAllWorkTypes"
                          },
                          (v27/*: any*/)
                        ]
                      },
                      (v23/*: any*/),
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "requiredOnInput"
                          }
                        ],
                        "concreteType": "JiraFieldWorkTypeRequiredCustomization",
                        "kind": "LinkedField",
                        "name": "requiredOnCustomizationsV2",
                        "plural": true,
                        "selections": [
                          (v28/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "isRequired"
                          },
                          (v27/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "JiraFieldSchemeOperations",
                        "kind": "LinkedField",
                        "name": "fieldSchemeOperations",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "canRemove"
                          }
                        ]
                      },
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "descriptionsInput"
                          }
                        ],
                        "concreteType": "JiraFieldWorkTypeDescriptionCustomization",
                        "kind": "LinkedField",
                        "name": "descriptionCustomisationsV2",
                        "plural": true,
                        "selections": [
                          (v28/*: any*/),
                          (v24/*: any*/),
                          {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "workTypes",
                            "plural": true,
                            "selections": [
                              (v23/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "isHighlighted"
                      }
                    ]
                  },
                  (v17/*: any*/)
                ]
              },
              (v18/*: any*/)
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              (v20/*: any*/),
              (v19/*: any*/)
            ]
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__id"
              }
            ]
          }
        ]
      },
      {
        "args": (v22/*: any*/),
        "filters": [
          "cloudId",
          "input"
        ],
        "handle": "connection",
        "key": "associatedFieldsTable_adminPagesFieldScheme_jira_fieldSchemeAssociatedFields",
        "kind": "LinkedHandle",
        "name": "jira_fieldSchemeAssociatedFields"
      },
      {
        "alias": "fieldSchemeNode",
        "args": (v11/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v17/*: any*/),
          (v23/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "schemeId"
              },
              (v13/*: any*/),
              (v15/*: any*/),
              {
                "concreteType": "JiraIssueTypeConnection",
                "kind": "LinkedField",
                "name": "associatedIssueTypes",
                "plural": false,
                "selections": (v29/*: any*/)
              },
              {
                "filters": (v30/*: any*/),
                "handle": "connection",
                "key": "FilterSelectWorkType_scheme_associatedIssueTypes",
                "kind": "LinkedHandle",
                "name": "associatedIssueTypes"
              },
              {
                "concreteType": "JiraIssueTypeConnection",
                "kind": "LinkedField",
                "name": "requiredOnIssueTypes",
                "plural": false,
                "selections": (v29/*: any*/)
              },
              {
                "filters": (v30/*: any*/),
                "handle": "connection",
                "key": "FilterSelectRequiredOn_scheme_requiredOnIssueTypes",
                "kind": "LinkedHandle",
                "name": "requiredOnIssueTypes"
              },
              (v14/*: any*/)
            ],
            "type": "JiraFieldScheme"
          }
        ]
      },
      {
        "condition": "isPerSchemeFieldLimitEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v8/*: any*/),
            "kind": "ScalarField",
            "name": "jira_fieldsPerSchemeLimit"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "60813beea58cb330d539e5ec8dacf95643df5e4008ab6e2ca093628ccd5cf9a0",
    "metadata": {},
    "name": "FieldSchemePageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "29e4f2ab73e1cffbee972dfc0d39e0ec";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
